<template>
<div>

</div>
</template>

<script>
export default {
  name: 'box',
};
</script>

<style scoped>

</style>
